var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcActionMultiDownload({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M3 19v-3h2v3h14v-3h2v3a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2Z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M8 12.586V4h2v8.586l2.293-2.293 1.414 1.414L9 16.414l-4.707-4.707 1.414-1.414L8 12.586Z",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M14 12.586V4h2v8.586l2.293-2.293 1.414 1.414L15 16.414l-3.707-3.707 1.414-1.414L14 12.586Z",
    clipRule: "evenodd",
    opacity: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcActionMultiDownload);
export default __webpack_public_path__ + "static/media/ic_action_multi_download.46fbe0333e49cbc18632ccd2a8eedf0b.svg";
export { ForwardRef as ReactComponent };